import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './PrivacyTerms.css';

const PrivacyTerms: React.FC = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<'privacy' | 'terms'>('privacy');

  return (
    <div className="privacy-terms-page">
      <div className="container">
        <div className="page-header">
          <h1>{t('privacyTerms.title')}</h1>
          <p>{t('privacyTerms.subtitle')}</p>
        </div>

        <div className="tabs-container">
          <div className="tabs">
            <button 
              className={`tab ${activeTab === 'privacy' ? 'active' : ''}`}
              onClick={() => setActiveTab('privacy')}
            >
              {t('privacyTerms.privacyPolicy')}
            </button>
            <button 
              className={`tab ${activeTab === 'terms' ? 'active' : ''}`}
              onClick={() => setActiveTab('terms')}
            >
              {t('privacyTerms.termsOfService')}
            </button>
          </div>

          <div className="tab-content">
            {activeTab === 'privacy' && (
              <div className="privacy-policy">
                <div className="document-header">
                  <h2>{t('privacyTerms.privacyPolicy')}</h2>
                  <p className="last-updated">{t('privacyTerms.lastUpdated')}: {t('privacyTerms.updateDate')}</p>
                </div>

                <div className="document-content">
                  <section>
                    <h3>{t('privacy.introduction.title')}</h3>
                    <p>{t('privacy.introduction.content')}</p>
                  </section>

                  <section>
                    <h3>{t('privacy.informationCollection.title')}</h3>
                    <p>{t('privacy.informationCollection.content')}</p>
                    <ul>
                      <li>{t('privacy.informationCollection.personalInfo')}</li>
                      <li>{t('privacy.informationCollection.usageData')}</li>
                      <li>{t('privacy.informationCollection.cookies')}</li>
                    </ul>
                  </section>

                  <section>
                    <h3>{t('privacy.informationUse.title')}</h3>
                    <p>{t('privacy.informationUse.content')}</p>
                    <ul>
                      <li>{t('privacy.informationUse.provideServices')}</li>
                      <li>{t('privacy.informationUse.communicate')}</li>
                      <li>{t('privacy.informationUse.improve')}</li>
                      <li>{t('privacy.informationUse.legal')}</li>
                    </ul>
                  </section>

                  <section>
                    <h3>{t('privacy.informationSharing.title')}</h3>
                    <p>{t('privacy.informationSharing.content')}</p>
                    <ul>
                      <li>{t('privacy.informationSharing.serviceProviders')}</li>
                      <li>{t('privacy.informationSharing.legalRequirements')}</li>
                      <li>{t('privacy.informationSharing.consent')}</li>
                    </ul>
                  </section>

                  <section>
                    <h3>{t('privacy.dataSecurity.title')}</h3>
                    <p>{t('privacy.dataSecurity.content')}</p>
                  </section>

                  <section>
                    <h3>{t('privacy.userRights.title')}</h3>
                    <p>{t('privacy.userRights.content')}</p>
                    <ul>
                      <li>{t('privacy.userRights.access')}</li>
                      <li>{t('privacy.userRights.correction')}</li>
                      <li>{t('privacy.userRights.deletion')}</li>
                      <li>{t('privacy.userRights.portability')}</li>
                    </ul>
                  </section>

                  <section>
                    <h3>{t('privacy.cookies.title')}</h3>
                    <p>{t('privacy.cookies.content')}</p>
                  </section>

                  <section>
                    <h3>{t('privacy.contact.title')}</h3>
                    <p>{t('privacy.contact.content')}</p>
                    <p>
                      <strong>{t('privacy.contact.email')}:</strong> info@pejapeaceforum.org<br />
                      <strong>{t('privacy.contact.address')}:</strong> {t('privacy.contact.addressValue')}
                    </p>
                  </section>
                </div>
              </div>
            )}

            {activeTab === 'terms' && (
              <div className="terms-of-service">
                <div className="document-header">
                  <h2>{t('privacyTerms.termsOfService')}</h2>
                  <p className="last-updated">{t('privacyTerms.lastUpdated')}: {t('privacyTerms.updateDate')}</p>
                </div>

                <div className="document-content">
                  <section>
                    <h3>{t('terms.acceptance.title')}</h3>
                    <p>{t('terms.acceptance.content')}</p>
                  </section>

                  <section>
                    <h3>{t('terms.useOfService.title')}</h3>
                    <p>{t('terms.useOfService.content')}</p>
                    <ul>
                      <li>{t('terms.useOfService.permitted')}</li>
                      <li>{t('terms.useOfService.prohibited')}</li>
                    </ul>
                  </section>

                  <section>
                    <h3>{t('terms.userAccounts.title')}</h3>
                    <p>{t('terms.userAccounts.content')}</p>
                  </section>

                  <section>
                    <h3>{t('terms.intellectualProperty.title')}</h3>
                    <p>{t('terms.intellectualProperty.content')}</p>
                  </section>

                  <section>
                    <h3>{t('terms.disclaimers.title')}</h3>
                    <p>{t('terms.disclaimers.content')}</p>
                  </section>

                  <section>
                    <h3>{t('terms.limitationOfLiability.title')}</h3>
                    <p>{t('terms.limitationOfLiability.content')}</p>
                  </section>

                  <section>
                    <h3>{t('terms.indemnification.title')}</h3>
                    <p>{t('terms.indemnification.content')}</p>
                  </section>

                  <section>
                    <h3>{t('terms.termination.title')}</h3>
                    <p>{t('terms.termination.content')}</p>
                  </section>

                  <section>
                    <h3>{t('terms.governingLaw.title')}</h3>
                    <p>{t('terms.governingLaw.content')}</p>
                  </section>

                  <section>
                    <h3>{t('terms.changes.title')}</h3>
                    <p>{t('terms.changes.content')}</p>
                  </section>

                  <section>
                    <h3>{t('terms.contact.title')}</h3>
                    <p>{t('terms.contact.content')}</p>
                    <p>
                      <strong>{t('terms.contact.email')}:</strong> info@pejapeaceforum.org<br />
                      <strong>{t('terms.contact.address')}:</strong> {t('terms.contact.addressValue')}
                    </p>
                  </section>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyTerms;
